<template>
  <div class="flex mt-10">
    <div class="mr-5">
      <img
        class="user-profile-img"
        style="max-width: 95px; background-color: grey;"
        :src="src || `//via.placeholder.com/${w}x${h}`"
      />
    </div>

    <div>
      <label
        v-if="label"
        class="mb-3"
      >{{ computedLabel }}</label>
      <p class="mb-2 small">
        Size: {{ `${w}x${h}` }} <br />
        Max file: {{ maxSize }}
      </p>

      <input
        type="file"
        @change="onFileChange"
        ref="file"
      >
    </div>
  </div>
</template>

<script>
import { uploadFile } from '@/api/storage'
import filesize from 'filesize'

export default {
  props: {
    src: {
      type: String,
      default: ''
    },
    w: {
      type: Number,
      default: 400
    },
    h: {
      type: Number,
      default: 300
    },
    label: {
      type: String,
      default: ''
    },
    maxSize: {
      type: String,
      default: '1MB'
    },
    filename: {
      type: String,
      default: 'file'
    },
    folder: {
      type: String,
      default: 'upload'
    }
  },
  data() {
    return {
      uploadTask: '',
      loading: false,
      progress: {
        transferred: '',
        total: ''
      },
    }
  },
  methods: {
    onFileChange () {
      var file = this.$refs.file.files[0]

      if (file) {
        this.$vs.notify({
          title: 'Warning',
          text: 'Uploading file...',
          color: 'warning',
          icon: 'cloud_upload'
        })

        var fileExtension = file.name.split('.')

        this.loading = true
        this.uploadTask = uploadFile(`${this.folder}/${this.filename}-${Date.now()}.${fileExtension.pop()}`, file)
          // .then(snapshot => {
          //   this.$emit('upload-success', snapshot)
          //   this.notifySuccess('Image uploaded')
          // })
          // .catch(err => {
          //   this.notifyError(err.msg)
          // })
      }
    },
    uploadSuccess (downloadURL) {
      this.$emit('upload-success', downloadURL)
        this.notifySuccess('Image uploaded')
    }
  },
  computed: {
    computedLabel() {
      if (this.loading) {
        return `Uploading ${filesize(this.progress.transferred)} / ${filesize(this.progress.total)}`
      } else {
        return this.label
      }
    }
  },
  watch: {
    uploadTask: function () {
      this.uploadTask.on('state_changed', (snapshot) => {
        this.progress.transferred = snapshot.bytesTransferred
        this.progress.total = snapshot.totalBytes
      })

      this.uploadTask.then((snapshot) => {
        snapshot.ref.getDownloadURL()
          .then((downloadURL) => {
            this.uploadSuccess(downloadURL)
            this.loading = false
          })

      })
    }
  }
}
</script>
